module.exports = __webpack_public_path__ + "static/media/play_button.28a6eff8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/play_button.svg
// module id = 319
// module chunks = 2